export const NumericRange = {
  from(start: number): { to(end: number): number[] } {
    return {
      to(end: number): number[] {
        const result: number[] = [];
        for (let i = start; i <= end; i++) {
          result.push(i);
        }
        return result;
      },
    };
  },
};
